import dayjs from 'dayjs'
import { Card, CardBody } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { TIPI_BILANCIA } from '../../constants'
import { Proposta } from '../../types'
import { CardTable } from '../../components/StickyTable'

interface PropostaElencoBilanceInterface {
  preferenze_orari: Proposta['preferenze_orari']
  note: Proposta['note']
  bilance_data?: Proposta['bilance_data']
  tipo_intervento: Proposta['tipo_intervento']
}

type CardElencoBilanceProps = {
  proposta: PropostaElencoBilanceInterface | undefined
}

export function CardElencoBilance({ proposta }: CardElencoBilanceProps) {
  return (
    <Card>
      <CardBody>
        <div className="heading-h4 d-flex align-items-center">
          <span className="material-icons text-secondary me-2">scale</span> Note ed elenco bilance
        </div>
        <div className="mt-3">
          <label className="label-m">Orari e preferenze</label>
          <textarea className="form-control mt-1" rows={5} value={proposta?.preferenze_orari ?? ''} readOnly />
        </div>
        <div className="mt-2">
          <label className="label-m">Note</label>
          <textarea className="form-control mt-1" rows={5} value={proposta?.note ?? ''} readOnly />
        </div>
        <div style={{ height: 400 }} className="overflow-auto mt-3">
          <CardTable className="table table-bottaro">
            <thead className="position-sticky top-0 bg-white">
              <tr>
                <th>Matricola</th>
                <th>Tipo</th>
                <th>Reparto</th>
                <th>Data scadenza</th>
              </tr>
            </thead>
            <tbody>
              {proposta?.bilance_data &&
                proposta?.bilance_data.map((b) => (
                  <tr key={b.id}>
                    <td>
                      <Link to={`/bilance/${b.id}`} className="link-md">
                        {b.matricola}
                      </Link>
                    </td>
                    <td>{TIPI_BILANCIA.find((t) => t.value === b.tipo_bilancia)?.label ?? b.tipo_bilancia}</td>
                    <td>{b.reparto}</td>
                    <td>
                      {proposta?.tipo_intervento === 'rapporto_taratura'
                        ? dayjs(b.data_scadenza_taratura).format('DD/MM/YYYY')
                        : dayjs(b.data_scadenza_periodica).format('DD/MM/YYYY')}
                    </td>
                  </tr>
                ))}
            </tbody>
          </CardTable>
        </div>
      </CardBody>
    </Card>
  )
}
